<!-- Facebook in-stream reels -->
<div class="fsr">
  <!-- The host post's header, as a skeleton -->
  <div class="fsr-header">
    <span class="fsr-avatar"></span>
    <div class="fsr-header-lines">
      <span class="fsr-bar" style="width: 136px"></span>
      <span class="fsr-bar" style="width: 80px"></span>
    </div>
    <i class="bi bi-three-dots fsr-menu"></i>
  </div>

  <!-- The ad -->
  <a class="fsr-link" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <app-meta-creative [src]="data.creative" [kind]="data.creativeKind" slot="feed"></app-meta-creative>
    <div class="fsr-card">
      <img class="fsr-logo" [src]="avatar" alt="" />
      <div class="fsr-copy">
        <div class="fsr-domain">{{ domain }}</div>
        <div class="fsr-headline">{{ headline }}</div>
        <div class="fsr-text">{{ primaryText }}</div>
      </div>
      <i class="bi bi-three-dots fsr-card-menu"></i>
    </div>
  </a>

  <!-- The host post's footer -->
  <div class="fsr-stats">
    <span class="fsr-stat" style="width: 160px"></span>
    <span class="fsr-stat" style="width: 78px"></span>
  </div>
  <div class="fsr-actions">
    <span class="fsr-action"><i class="bi bi-hand-thumbs-up"></i>Like</span>
    <span class="fsr-action"><i class="bi bi-chat"></i>Komentiraj</span>
    <span class="fsr-action"><i class="bi bi-reply fsr-share"></i>Share</span>
  </div>
</div>
